<template>
  <div id="class">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_one">
        <div class="con_box">
          <div class="tx_box" v-html="showIntroduction()">
            
          </div>
          <div class="boxall">
            <div @click="selectClass(classitem)" v-for="(classitem,index) in classes" :key="index">
              <div class="box2">
                <div class="class_box">
                  <div class="class_pic1" :style="{background: 'url(' + classitem.pictureUrl + ')'}">
                    <div class="class_title">{{showName(classitem)}}</div>
                  </div>
                  <div class="fix"></div>
                </div>
              </div>
            </div>
            <div class="fix"></div>
          </div>
          <div class="tx_box mt20" v-html="showApplication()">
            
          </div>
        </div>
      </div>
    </div>
    <router-view :classitem="nowClassitem" @initClass="initClass" v-if="$route.meta.keepAliveSub"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'class',
  data() {
    return {

      classes: [],
      nowClassitem: '',
      course: '',
      locale: sessionStorage.getItem('locale'),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initCourse();
      this.initClasses();
    },
    initClasses() {
      this.getClassesData();
    },
    initCourse() {
      this.getCourseData();
    },
    getClassesData() {
      axios.get(API.class + '?courseid=1')
        .then(response => {
          this.classes = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    initCourses() {
      this.getCoursesData();
    },
    initClass(classitem) {
      this.nowClassitem = classitem;
    },
    getCourseData() {
      axios.get(API.course + '?id=1')
        .then(response => {
          this.course = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    selectClass(classitem) {
      this.nowClassitem = classitem;
      this.$router.push({ name: 'class_item', params: { classid: classitem.id } });
    },
    

    showName(classitem) {
      return sessionStorage.locale === 'CH' ? classitem.nameCh : classitem.nameEn;
    },
    showIntroduction() {
      return sessionStorage.locale === 'CH' ? (this.course.introductionCh) : (this.course.introductionEn);
    },
    showApplication() {
      return sessionStorage.locale === 'CH' ? (this.course.applicationCh) : (this.course.applicationEn);
    }
  },
}

</script>
<style lang="scss">

#class{
  .class_pic1{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// Class.vue?0b3befc8